import { useState } from 'react';
import { cn } from '@/lib/utils';
import { Tool } from '@/types/database';

export const PRICING_LABEL: Record<string, string> = {
  free: 'Free',
  freemium: 'Freemium',
  paid: 'Paid',
  enterprise: 'Enterprise',
};

export function ToolLogo({ tool, className }: { tool: Pick<Tool, 'name' | 'logo_url'>; className?: string }) {
  const [failed, setFailed] = useState(false);
  if (tool.logo_url && !failed) {
    return (
      <img
        src={tool.logo_url}
        alt=""
        loading="lazy"
        onError={() => setFailed(true)}
        className={cn('rounded-xl object-contain bg-card border border-border/60 p-1 shrink-0', className)}
      />
    );
  }
  return (
    <div className={cn('rounded-xl bg-primary/10 text-primary font-semibold flex items-center justify-center shrink-0', className)}>
      {tool.name.charAt(0)}
    </div>
  );
}
